import type { IconAsset } from '../Icon.types';

const code = (
  <path
    d='M16.095,14.523h-.828l-.293-.283a6.82,6.82,0,1,0-.733.733l.283.293v.828l5.238,5.227,1.561-1.561Zm-6.285,0a4.714,4.714,0,1,1,4.714-4.714A4.708,4.708,0,0,1,9.809,14.523Z'
    fill='currentColor'
    fillRule='evenodd'
    transform='translate(-0.384 -0.383)'
  />
);

export const search: IconAsset = {
  regular: {
    l: {
      code,
    },
    m: {
      code,
    },
    s: {
      code,
    },
  },
  bold: {
    l: {
      code,
    },
    m: {
      code,
    },
    s: {
      code,
    },
  },
};
